import { Button, EmptyState } from '@orbind/ui'
import { ehSemPermissao, mensagemDoServidor } from './estados-erro.ts'

/**
 * O que a Comunicação mostra quando a consulta NÃO deu certo.
 *
 * Até aqui, falha de rede e falta de permissão caíam no mesmo lugar do estado
 * vazio: a lista de conversas aparecia sem nada, e um canal que a pessoa não
 * pode ver dizia "Nenhuma mensagem ainda" — o que é mentira, e das piores,
 * porque a pessoa conclui que a conversa está vazia em vez de fechada para ela.
 *
 * São situações diferentes e a saída de cada uma é diferente: erro se tenta de
 * novo, falta de permissão se resolve com quem administra o canal.
 */

export function ErroDaConversa({
  erro,
  onTentarDeNovo,
  oQue,
}: {
  erro: unknown
  onTentarDeNovo?: () => void
  /** O que falhou, no plural e em minúscula: "as conversas", "as mensagens". */
  oQue: string
}) {
  if (ehSemPermissao(erro)) {
    return (
      <EmptyState
        icon="fas fa-lock"
        title="Você não tem acesso a esta conversa"
        description="Quem administra o canal pode incluir você. Enquanto isso, o conteúdo fica oculto."
      />
    )
  }

  /*
   * A mensagem do servidor entra quando existe: ela costuma dizer algo
   * específico ("workspace suspenso") que um texto genérico esconderia.
   */
  const doServidor = mensagemDoServidor(erro)
  return (
    <EmptyState
      icon="fas fa-triangle-exclamation"
      title={`Não foi possível carregar ${oQue}`}
      description={doServidor || 'A conexão falhou no caminho. Tente de novo em instantes.'}
      action={
        onTentarDeNovo ? (
          <Button variant="secondary" onClick={onTentarDeNovo}>
            Tentar de novo
          </Button>
        ) : undefined
      }
    />
  )
}
